import { notifications } from "@mantine/notifications";

interface NotificationData {
  id: string;
  count: number;
  title: string;
  color: string;
}

// Global notification storage for non-hook usage
const globalNotifications: Record<string, NotificationData> = {};

export const Notification = (title: string, message: string, color: string) => {
  const existingNotification = globalNotifications[message];

  if (existingNotification) {
    // Update existing notification with new count and reset auto-hide timer
    const newCount = existingNotification.count + 1;
    globalNotifications[message].count = newCount;

    notifications.update({
      id: existingNotification.id,
      title: existingNotification.title,
      message: `${message} (${newCount})`,
      color: existingNotification.color,
      autoClose: 5000,
      withCloseButton: true,
      onClose: () => {
        delete globalNotifications[message];
      },
    });
  } else {
    // Create new notification
    const id = `notification-${Date.now()}-${Math.random()}`;
    globalNotifications[message] = { id, count: 1, title, color };

    notifications.show({
      id,
      title,
      message,
      color,
      autoClose: 5000,
      withCloseButton: true,
      style: { zIndex: 9999 },
      onClose: () => {
        delete globalNotifications[message];
      },
    });
  }
};
